import React,{Component} from 'react';
import './AdminLocations.css';
import AdminHeaderTool from '../Components/AdminHeaderTool/AdminHeaderTool';
import NabarAdmin from '../Components/NabarAdmin/NabarAdmin';
import AdminTableDetails from '../Components/AdminTableDetails/AdminTableDetails';
import AdminCreateLocations from '../Components/AdminCreateLocations/AdminCreateLocations';
import iconlocationsm from '../../../image/iconlocationsm.svg'


class AdminLocations extends Component{
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            search:'',
        }
    }
    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };
    render(){
        return(
            <div>
                <div className="row  AppEN mx-0">
                    <div className="col-md-1 px-0 ">
                        <NabarAdmin />
                    </div>
                    <div className=" AdminLocations Admin col-md-11 px-4">
                    <AdminHeaderTool/>
                        <h3 className=" fontsize9 my-0 order-8 order-md-2">Locations</h3>
                    <div className="row">
                            <div className="col-md-4 px-2 py-3 order-8 order-md-2">
                                   <AdminTableDetails icon={iconlocationsm} state={this.state} handleChange={this.handleChange}/>
                            </div>
                            <div className="col-md-8 px-4 py-3 order-5"> 
                                    <div className="picbg">
                                        <AdminCreateLocations/>
                                    </div>
                            </div>
                            </div>

                    </div>
                </div>

            </div>
        )
    }
}
export default AdminLocations;